module.exports = __webpack_public_path__ + "img/backgr-home-second-section1.d337faac.png";